import { AccordionItem, Text, List, Stack } from 'braid-design-system';
export const Privacy = () => (
  <AccordionItem id="privacy" label="Privacy">
    <List type="number" start={34}>
      <Stack space="medium">
        <Text>
          You must in respect of any Personal Information which you receive or
          learn via your use of the SEEK API:
        </Text>
        <List type="alpha">
          <Text>
            not use, disclose and store the Personal Information for any purpose
            other than for the purpose of carrying out the services that a
            Mutual Customer has engaged you for;
          </Text>
          <Stack space="medium">
            <Text>
              for Personal Information which you have received or learnt
              directly from us, you must use and disclose the Personal
              Information only:
            </Text>
            <List type="roman">
              <Text>
                to the extent necessary for the proper performance and
                integration of the SEEK API; or
              </Text>
              <Text>with our prior written consent;</Text>
            </List>
          </Stack>
          <Text>
            without limiting the effect of clauses 34a) and b), not use,
            disclose, copy or modify the Personal Information for your own
            purposes, including but not limited to any database building,
            marketing, advertising or promotional purposes;
          </Text>
          <Text>
            comply with the Privacy Laws of the relevant individual’s country as
            if you were an entity regulated by such Privacy Laws;
          </Text>
          <Text>
            not do anything or omit to do anything that it could reasonably
            expect would cause any member of the SEEK Group to breach its
            obligations under a Privacy Law; and
          </Text>
          <Text>
            comply with all our reasonable directions relating to the protection
            of the Personal information and compliance with the Privacy Laws,
            and cooperate fully with us in the resolution of any complaint
            alleging a breach of any Privacy Law.
          </Text>
        </List>
      </Stack>
      <Text>
        You have, and maintain, a privacy policy in relation to the Data
        collected by you that complies, in all material respects, with the
        requirements of all applicable Privacy Laws.
      </Text>
      <Text>
        You have, and maintain your own user terms and privacy policy, which
        must be readily accessible to the users of your Recruitment Software.
      </Text>
    </List>
  </AccordionItem>
);
